import React from "react";
import {UserEmailAlerts} from "./UserEmailAlerts";
import {UserContentBase} from "./UserContentBase";


export class UserAlertsContent extends UserContentBase {
    renderModuleMarketingAlerts() {
        if(this.state.canUseModuleMarketingAlerts)
            return (<UserEmailAlerts userId={this.props.userId} />);
    }

    render() {
        return (
            <section className="section-content">
                {this.renderHeaderAndTabs("first")}
                <div className="section-body h-items">
                    {this.renderModuleMarketingAlerts()}
                </div>
            </section>
        )
    }
}
